// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   CARD
========================================= */

.FrequencyBucketTable_card__B2mOT {
    border-radius: 12px;
    z-index: 1;
    padding: 10px 12px;
    background-color: #ffffff;
}

/* =========================================
   CARD HEADER
========================================= */

.FrequencyBucketTable_cardHeader__j53zj {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 8px;
    flex-wrap: wrap;
}

.FrequencyBucketTable_titleBar__SXoW7 {
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background-color: var(--primary-blue-theme-color);
    display: inline-block;
    align-self: center;
}

.FrequencyBucketTable_title__rAN-1 {
    font-size: 14px;
    font-weight: 700;
    color: #26384a;
    white-space: nowrap;
}

.FrequencyBucketTable_subtitle__jQveM {
    font-size: 11px;
    color: gray;
    font-weight: 500;
}

/* =========================================
   TABLE WRAPPER
========================================= */

.FrequencyBucketTable_tableWrapper__ZIYdg {
    width: 100%;
    border-radius: 8px;

    max-height: 600px;
    min-height: 120px;

    overflow-x: auto;
    overflow-y: auto;
}

/* =========================================
   MAIN TABLE
========================================= */

.FrequencyBucketTable_mainTable__FBEuG {
    width: 100%;
    margin-bottom: 0;

    border-collapse: separate;
    border-spacing: 0;

    table-layout: fixed;
}

/* =========================================
   COLUMN WIDTHS
========================================= */

.FrequencyBucketTable_colCity__3J4h2 {
    width: 15%;
}

.FrequencyBucketTable_colStatus__NR1Av {
    width: 3%;
}

.FrequencyBucketTable_colDelayPct__Ck71o {
    width: 6%;
}

.FrequencyBucketTable_colNarrow__l7apc {
    width: 6%;
}

.FrequencyBucketTable_colBucket__c1loM {
    width: 4%;
}

/* =========================================
   TABLE HEADER
========================================= */

.FrequencyBucketTable_mainTable__FBEuG thead th {
    background-color: var(--primary-blue-theme-color);
    color: #ffffff;

    font-size: 11px;
    font-weight: 700;

    text-align: center;
    vertical-align: middle;

    white-space: normal;
    overflow-wrap: normal;
    word-break: normal;

    line-height: 1.2;

    /* same header height as the Device Transmission table (30px hour header) */
    box-sizing: content-box;
    height: 30px;
    padding: 0 4px;

    position: sticky;
    top: 0;

    z-index: 3;

    border-bottom: 1px solid #e3e8ee;
}

/* =========================================
   BODY / ROWS
========================================= */

.FrequencyBucketTable_mainTable__FBEuG tbody td {
    font-size: 12px;

    text-align: center;
    vertical-align: middle;

    padding: 4px 6px;

    white-space: nowrap;

    overflow: hidden;
    text-overflow: ellipsis;
}

.FrequencyBucketTable_dataRow__FFH1t {
    transition: background-color 0.2s ease;
}

/* =========================================
   CITY ROW
========================================= */

.FrequencyBucketTable_cityRow__GT59c td {
    background-color: #ffffff;
}

.FrequencyBucketTable_cityRow__GT59c:hover td {
    background-color: #f8fbff;
}

.FrequencyBucketTable_cityRowActive__Z3jFc td {
    background-color: #edf5fc !important;
}

/* =========================================
   CITY CELL
========================================= */

.FrequencyBucketTable_cityCell__9hVxj {
    text-align: left !important;

    white-space: nowrap;

    overflow: hidden;

    max-width: 0;
}

.FrequencyBucketTable_cityCell__9hVxj:hover {
    background-color: transparent !important;
}

.FrequencyBucketTable_cityContent__u0483 {
    display: flex;

    align-items: center;

    gap: 6px;

    min-width: 0;
}

.FrequencyBucketTable_accordionIcon__kvSZf {
    display: inline-flex;

    align-items: center;
    justify-content: center;

    width: 12px;

    flex-shrink: 0;

    color: var(--primary-blue-theme-color);
}

.FrequencyBucketTable_cityName__jCccL {
    color: #26384a;

    font-size: 12px;

    font-weight: 700;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;
}

/* =========================================
   DEPOT
========================================= */

.FrequencyBucketTable_depotRow__8HWuW {
    background-color: #fafbfc;

    animation: FrequencyBucketTable_depotSlideIn__cB7i0 0.15s ease-out;
}

.FrequencyBucketTable_depotRow__8HWuW td {
    background-color: #fafbfc !important;

    color: #6c757d;

    padding-top: 3px !important;
    padding-bottom: 3px !important;

    border-top: 0 !important;
}

.FrequencyBucketTable_depotRow__8HWuW:hover td {
    background-color: #f4f6f8 !important;
}

.FrequencyBucketTable_depotCell__drGxZ {
    position: relative;

    text-align: left !important;

    white-space: nowrap;

    overflow: hidden;

    max-width: 0;
}

.FrequencyBucketTable_depotName__Kfmmn {
    font-size: 11px !important;

    font-weight: 500 !important;

    color: #697681 !important;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;
}

.FrequencyBucketTable_depotIndicator__zqoaS {
    width: 6px;
    height: 6px;

    border-radius: 50%;

    background-color: #aeb8c1;

    display: inline-block;

    margin-left: 18px;
}

/* =========================================
   DEPOT ANIMATION
========================================= */

@keyframes FrequencyBucketTable_depotSlideIn__cB7i0 {
    from {
        opacity: 0;
        transform: translateY(-3px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* =========================================
   STATUS BADGE
========================================= */

.FrequencyBucketTable_statusBadge__G7Z-m {
    display: inline-block;

    font-size: 10px;

    font-weight: 600;

    padding: 3px 3px;

    border-radius: 10px;

    white-space: nowrap;
}

.FrequencyBucketTable_statusHealthy__m2k1W {
    /* background-color: #eafaf0; */
    background-color: #1aa054;

    /* color: #1aa054; */

    border: 1px solid #b9ecd1;
}

.FrequencyBucketTable_statusUnhealthy__3pmxR {
    /* background-color: #fdeef1; */
     background-color: #e5384d;

    /* color: #e5384d; */

    border: 1px solid #f6c6cf;
}

/* =========================================
   DELAY PACKET %
========================================= */

.FrequencyBucketTable_delayPct__ISuFb {
    font-weight: 700;
}

/* =========================================
   BUCKET CELLS
========================================= */

.FrequencyBucketTable_bucketCell__CtAor {
    font-weight: 600;
}

/* =========================================
   COLOR TONES
========================================= */

.FrequencyBucketTable_tone_green__umHCs {
    color: #1aa054;
}

.FrequencyBucketTable_tone_yellow__xjg1C {
    color: #e6b800;
}

.FrequencyBucketTable_tone_orange__Q4bfD {
    color: #e08a1e;
}

.FrequencyBucketTable_tone_red__acoJi {
    color: #e5384d;
}

.FrequencyBucketTable_tone_grey__HGuwZ {
    color: #aeb8c1;

    font-weight: 400;
}

/* =========================================
   LOADING
========================================= */

.FrequencyBucketTable_loadingState__3xxbW {
    display: flex;

    align-items: center;
    justify-content: center;

    gap: 6px;

    padding: 18px;

    color: #6c757d;

    font-size: 12px;
}

.FrequencyBucketTable_spinner__WAthB {
    width: 14px;
    height: 14px;

    border-radius: 50%;

    border: 2px solid #dee2e6;

    border-top-color: var(--primary-blue-theme-color);

    animation: FrequencyBucketTable_spin__BwEdW 0.7s linear infinite;
}

@keyframes FrequencyBucketTable_spin__BwEdW {
    to {
        transform: rotate(360deg);
    }
}

/* =========================================
   MOBILE
========================================= */

@media (max-width: 768px) {
    .FrequencyBucketTable_tableWrapper__ZIYdg {
        min-height: 200px;
        max-height: 420px;
    }

    .FrequencyBucketTable_mainTable__FBEuG thead th {
        font-size: 9px;
        padding: 0 3px;
    }

    .FrequencyBucketTable_mainTable__FBEuG tbody td {
        font-size: 10px;
        padding: 3px 4px;
    }
}


/* =====================================================================
 * FREQUENCY DISTRIBUTION TABLE
 * ===================================================================== */

/* keeps the 11 columns readable on small screens; wrapper scrolls instead */
.FrequencyBucketTable_mainTable__FBEuG {
    min-width: 760px;
}

.FrequencyBucketTable_colLocation__Qm7PS {
    width: 17%;
}

.FrequencyBucketTable_colCount__1GdRS {
    width: 8%;
}

.FrequencyBucketTable_colFreq__defC4 {
    width: 8%;
}

/* =========================================
   CLICKABLE ROWS / CELLS
========================================= */

.FrequencyBucketTable_cityRow__GT59c,
.FrequencyBucketTable_depotRowClickable__XahuF {
    cursor: pointer;
}

.FrequencyBucketTable_depotLink__FGFuZ {
    padding: 0;
    border: 0;
    background: transparent;
    color: #697681;
    font-size: 11px;
    font-weight: 600;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
}

.FrequencyBucketTable_depotLink__FGFuZ:hover {
    color: #4b71a2;
    text-decoration: underline;
}

/* =========================================
   DEPOT VEHICLES POPOVER
========================================= */

.FrequencyBucketTable_popoverBody__EEHD\\+ {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px 16px 4px;
}

.FrequencyBucketTable_popoverMeta__Dh6qj {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}

.FrequencyBucketTable_metaChip__0pdkP {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 10px;
    background-color: #edf5fc;
    color: #4b71a2;
    font-size: 11px;
    font-weight: 600;
}

.FrequencyBucketTable_metaCount__0GHUq {
    margin-left: auto;
    color: #6b7280;
    font-size: 11px;
    font-weight: 600;
}

/* download icon at the right of the card title row */
.FrequencyBucketTable_downloadBtn__vhOYd {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;

    margin-right: 8px;
    padding: 2px;
    border: 0;
    background: transparent;

    color: #6b7280;
    cursor: pointer;
}

.FrequencyBucketTable_downloadBtn__vhOYd:hover {
    color: #022352;
}

/* download icon right after the vehicle count */
.FrequencyBucketTable_metaDownload__nnD9o {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    color: #6b7280;
    cursor: pointer;
}

.FrequencyBucketTable_metaDownload__nnD9o:hover {
    color: #022352;
}

/* vehicle multi-select: sits right after the city / date chips */
.FrequencyBucketTable_vehicleSelect__M0WgG {
    position: relative;
    /* above the table's sticky header (bootstrap .sticky-top = 1020) */
    z-index: 1030;
    margin-left: 4px;
    font-size: 12px;
}

.FrequencyBucketTable_vehicleMenuList__LfL4p {
    /* search box width (min(270px, 80vw)) + its 8px margin on each side */
    width: calc(min(270px, 80vw) + 16px);
    max-height: 220px;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #fff;
}

.FrequencyBucketTable_vehicleOption__VCDZo {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    color: #26384a;
    font-size: 12px;
    white-space: nowrap;
    cursor: pointer;
}

.FrequencyBucketTable_vehicleSelectAll__WhaqX {
    position: sticky;
    top: 0;
    border-bottom: 1px solid #e5e7eb;
    background-color: #fff;
    font-weight: 600;
}

.FrequencyBucketTable_vehicleOption__VCDZo:hover {
    background-color: #edf5fc;
}

.FrequencyBucketTable_vehicleOption__VCDZo input {
    flex-shrink: 0;
    margin: 0;
}

.FrequencyBucketTable_popoverTableWrapper__2Z-Zg {
    width: 100%;
    max-height: 380px;
    overflow: auto;
    border-radius: 8px;
}

@media (max-width: 768px) {
    .FrequencyBucketTable_popoverBody__EEHD\\+ {
        padding: 10px 10px 4px;
    }

    .FrequencyBucketTable_metaCount__0GHUq {
        margin-left: 0;
    }

    .FrequencyBucketTable_popoverTableWrapper__2Z-Zg {
        max-height: 320px;
    }
}

/* =========================================
   COLUMN WIDTH OVERRIDES (after base widths)
========================================= */

.FrequencyBucketTable_colStatus__NR1Av {
    width: 5%;
}

.FrequencyBucketTable_colBucket__c1loM {
    width: 8.5%;
}

/* =========================================
   POPOVER: VIN column + table width
========================================= */

.FrequencyBucketTable_colVin__qYsWO {
    width: 20%;
}

.FrequencyBucketTable_colReg__6Kx6R {
    width: 12%;
}

.FrequencyBucketTable_popoverTable__Qg2Yj {
    min-width: 820px;
}

.FrequencyBucketTable_vinText__GRCUU {
    color: #26384a;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.FrequencyBucketTable_locationRow__GOpA4 td {
    background-color: #ffffff;
}

.FrequencyBucketTable_locationRow__GOpA4:hover td {
    background-color: #f8fbff;
}

.FrequencyBucketTable_ignition__v-Oy1 {
  --track-off: #dbe3f1;
  --track-on: #5b86d6;
  --knob: #ffffff;
  --label: #2b3a55;
  --state: #5b7bb5;

  display: inline-flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
}

.FrequencyBucketTable_label__QrlQD {
  font-size: 16px;
  font-weight: 600;
  color: var(--label);
}

.FrequencyBucketTable_switch__J26qT {
  position: relative;
  width: 30px;
  height: 15px;
  flex: none;
}

.FrequencyBucketTable_input__f4j9O {
  position: absolute;
  inset: 0;
  opacity: 0;
  margin: 0;
  cursor: pointer;
}

.FrequencyBucketTable_track__yeU9K {
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: var(--track-off);
  transition: background 0.2s ease;
}

.FrequencyBucketTable_track__yeU9K::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: var(--knob);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease;
}

.FrequencyBucketTable_input__f4j9O:checked + .FrequencyBucketTable_track__yeU9K {
  background: var(--track-on);
}

.FrequencyBucketTable_input__f4j9O:checked + .FrequencyBucketTable_track__yeU9K::after {
  transform: translateX(15px);
}

.FrequencyBucketTable_input__f4j9O:focus-visible + .FrequencyBucketTable_track__yeU9K {
  outline: 2px solid var(--track-on);
  outline-offset: 2px;
}

.FrequencyBucketTable_state__Elxx9 {
  min-width: 32px;
  font-size: 14px;
  font-weight: 700;
  color: var(--state);
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/DeviceHealth/FrequencyBucketTable.module.css"],"names":[],"mappings":"AAAA;;2CAE2C;;AAE3C;IACI,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,iDAAiD;IACjD,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,WAAW;IACX,kBAAkB;;IAElB,iBAAiB;IACjB,iBAAiB;;IAEjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,WAAW;IACX,gBAAgB;;IAEhB,yBAAyB;IACzB,iBAAiB;;IAEjB,mBAAmB;AACvB;;AAEA;;2CAE2C;;AAE3C;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;;2CAE2C;;AAE3C;IACI,iDAAiD;IACjD,cAAc;;IAEd,eAAe;IACf,gBAAgB;;IAEhB,kBAAkB;IAClB,sBAAsB;;IAEtB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;;IAElB,gBAAgB;;IAEhB,2EAA2E;IAC3E,uBAAuB;IACvB,YAAY;IACZ,cAAc;;IAEd,gBAAgB;IAChB,MAAM;;IAEN,UAAU;;IAEV,gCAAgC;AACpC;;AAEA;;2CAE2C;;AAE3C;IACI,eAAe;;IAEf,kBAAkB;IAClB,sBAAsB;;IAEtB,gBAAgB;;IAEhB,mBAAmB;;IAEnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;2CAE2C;;AAE3C;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;2CAE2C;;AAE3C;IACI,2BAA2B;;IAE3B,mBAAmB;;IAEnB,gBAAgB;;IAEhB,YAAY;AAChB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;;IAEb,mBAAmB;;IAEnB,QAAQ;;IAER,YAAY;AAChB;;AAEA;IACI,oBAAoB;;IAEpB,mBAAmB;IACnB,uBAAuB;;IAEvB,WAAW;;IAEX,cAAc;;IAEd,sCAAsC;AAC1C;;AAEA;IACI,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;;IAEhB,gBAAgB;;IAEhB,uBAAuB;;IAEvB,mBAAmB;AACvB;;AAEA;;2CAE2C;;AAE3C;IACI,yBAAyB;;IAEzB,kEAAsC;AAC1C;;AAEA;IACI,oCAAoC;;IAEpC,cAAc;;IAEd,2BAA2B;IAC3B,8BAA8B;;IAE9B,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;;IAElB,2BAA2B;;IAE3B,mBAAmB;;IAEnB,gBAAgB;;IAEhB,YAAY;AAChB;;AAEA;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,yBAAyB;;IAEzB,gBAAgB;;IAEhB,uBAAuB;;IAEvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;;IAEX,kBAAkB;;IAElB,yBAAyB;;IAEzB,qBAAqB;;IAErB,iBAAiB;AACrB;;AAEA;;2CAE2C;;AAE3C;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;2CAE2C;;AAE3C;IACI,qBAAqB;;IAErB,eAAe;;IAEf,gBAAgB;;IAEhB,gBAAgB;;IAEhB,mBAAmB;;IAEnB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;;IAEzB,oBAAoB;;IAEpB,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;KAC9B,yBAAyB;;IAE1B,oBAAoB;;IAEpB,yBAAyB;AAC7B;;AAEA;;2CAE2C;;AAE3C;IACI,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;;IAEd,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;;IAEb,mBAAmB;IACnB,uBAAuB;;IAEvB,QAAQ;;IAER,aAAa;;IAEb,cAAc;;IAEd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,kBAAkB;;IAElB,yBAAyB;;IAEzB,iDAAiD;;IAEjD,gEAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;2CAE2C;;AAE3C;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;;AAGA;;0EAE0E;;AAE1E,4EAA4E;AAC5E;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;;2CAE2C;;AAE3C;;IAEI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,qDAAqD;AACrD;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;;IAEnB,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,uBAAuB;;IAEvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,gDAAgD;AAChD;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,iEAAiE;AACjE;IACI,kBAAkB;IAClB,mEAAmE;IACnE,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,sEAAsE;IACtE,oCAAoC;IACpC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;;2CAE2C;;AAE3C;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;;2CAE2C;;AAE3C;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,qEAAqE;AACvE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* =========================================\n   CARD\n========================================= */\n\n.card {\n    border-radius: 12px;\n    z-index: 1;\n    padding: 10px 12px;\n    background-color: #ffffff;\n}\n\n/* =========================================\n   CARD HEADER\n========================================= */\n\n.cardHeader {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    margin-bottom: 8px;\n    flex-wrap: wrap;\n}\n\n.titleBar {\n    width: 4px;\n    height: 16px;\n    border-radius: 2px;\n    background-color: var(--primary-blue-theme-color);\n    display: inline-block;\n    align-self: center;\n}\n\n.title {\n    font-size: 14px;\n    font-weight: 700;\n    color: #26384a;\n    white-space: nowrap;\n}\n\n.subtitle {\n    font-size: 11px;\n    color: gray;\n    font-weight: 500;\n}\n\n/* =========================================\n   TABLE WRAPPER\n========================================= */\n\n.tableWrapper {\n    width: 100%;\n    border-radius: 8px;\n\n    max-height: 600px;\n    min-height: 120px;\n\n    overflow-x: auto;\n    overflow-y: auto;\n}\n\n/* =========================================\n   MAIN TABLE\n========================================= */\n\n.mainTable {\n    width: 100%;\n    margin-bottom: 0;\n\n    border-collapse: separate;\n    border-spacing: 0;\n\n    table-layout: fixed;\n}\n\n/* =========================================\n   COLUMN WIDTHS\n========================================= */\n\n.colCity {\n    width: 15%;\n}\n\n.colStatus {\n    width: 3%;\n}\n\n.colDelayPct {\n    width: 6%;\n}\n\n.colNarrow {\n    width: 6%;\n}\n\n.colBucket {\n    width: 4%;\n}\n\n/* =========================================\n   TABLE HEADER\n========================================= */\n\n.mainTable thead th {\n    background-color: var(--primary-blue-theme-color);\n    color: #ffffff;\n\n    font-size: 11px;\n    font-weight: 700;\n\n    text-align: center;\n    vertical-align: middle;\n\n    white-space: normal;\n    overflow-wrap: normal;\n    word-break: normal;\n\n    line-height: 1.2;\n\n    /* same header height as the Device Transmission table (30px hour header) */\n    box-sizing: content-box;\n    height: 30px;\n    padding: 0 4px;\n\n    position: sticky;\n    top: 0;\n\n    z-index: 3;\n\n    border-bottom: 1px solid #e3e8ee;\n}\n\n/* =========================================\n   BODY / ROWS\n========================================= */\n\n.mainTable tbody td {\n    font-size: 12px;\n\n    text-align: center;\n    vertical-align: middle;\n\n    padding: 4px 6px;\n\n    white-space: nowrap;\n\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.dataRow {\n    transition: background-color 0.2s ease;\n}\n\n/* =========================================\n   CITY ROW\n========================================= */\n\n.cityRow td {\n    background-color: #ffffff;\n}\n\n.cityRow:hover td {\n    background-color: #f8fbff;\n}\n\n.cityRowActive td {\n    background-color: #edf5fc !important;\n}\n\n/* =========================================\n   CITY CELL\n========================================= */\n\n.cityCell {\n    text-align: left !important;\n\n    white-space: nowrap;\n\n    overflow: hidden;\n\n    max-width: 0;\n}\n\n.cityCell:hover {\n    background-color: transparent !important;\n}\n\n.cityContent {\n    display: flex;\n\n    align-items: center;\n\n    gap: 6px;\n\n    min-width: 0;\n}\n\n.accordionIcon {\n    display: inline-flex;\n\n    align-items: center;\n    justify-content: center;\n\n    width: 12px;\n\n    flex-shrink: 0;\n\n    color: var(--primary-blue-theme-color);\n}\n\n.cityName {\n    color: #26384a;\n\n    font-size: 12px;\n\n    font-weight: 700;\n\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n\n    white-space: nowrap;\n}\n\n/* =========================================\n   DEPOT\n========================================= */\n\n.depotRow {\n    background-color: #fafbfc;\n\n    animation: depotSlideIn 0.15s ease-out;\n}\n\n.depotRow td {\n    background-color: #fafbfc !important;\n\n    color: #6c757d;\n\n    padding-top: 3px !important;\n    padding-bottom: 3px !important;\n\n    border-top: 0 !important;\n}\n\n.depotRow:hover td {\n    background-color: #f4f6f8 !important;\n}\n\n.depotCell {\n    position: relative;\n\n    text-align: left !important;\n\n    white-space: nowrap;\n\n    overflow: hidden;\n\n    max-width: 0;\n}\n\n.depotName {\n    font-size: 11px !important;\n\n    font-weight: 500 !important;\n\n    color: #697681 !important;\n\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n\n    white-space: nowrap;\n}\n\n.depotIndicator {\n    width: 6px;\n    height: 6px;\n\n    border-radius: 50%;\n\n    background-color: #aeb8c1;\n\n    display: inline-block;\n\n    margin-left: 18px;\n}\n\n/* =========================================\n   DEPOT ANIMATION\n========================================= */\n\n@keyframes depotSlideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-3px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* =========================================\n   STATUS BADGE\n========================================= */\n\n.statusBadge {\n    display: inline-block;\n\n    font-size: 10px;\n\n    font-weight: 600;\n\n    padding: 3px 3px;\n\n    border-radius: 10px;\n\n    white-space: nowrap;\n}\n\n.statusHealthy {\n    /* background-color: #eafaf0; */\n    background-color: #1aa054;\n\n    /* color: #1aa054; */\n\n    border: 1px solid #b9ecd1;\n}\n\n.statusUnhealthy {\n    /* background-color: #fdeef1; */\n     background-color: #e5384d;\n\n    /* color: #e5384d; */\n\n    border: 1px solid #f6c6cf;\n}\n\n/* =========================================\n   DELAY PACKET %\n========================================= */\n\n.delayPct {\n    font-weight: 700;\n}\n\n/* =========================================\n   BUCKET CELLS\n========================================= */\n\n.bucketCell {\n    font-weight: 600;\n}\n\n/* =========================================\n   COLOR TONES\n========================================= */\n\n.tone_green {\n    color: #1aa054;\n}\n\n.tone_yellow {\n    color: #e6b800;\n}\n\n.tone_orange {\n    color: #e08a1e;\n}\n\n.tone_red {\n    color: #e5384d;\n}\n\n.tone_grey {\n    color: #aeb8c1;\n\n    font-weight: 400;\n}\n\n/* =========================================\n   LOADING\n========================================= */\n\n.loadingState {\n    display: flex;\n\n    align-items: center;\n    justify-content: center;\n\n    gap: 6px;\n\n    padding: 18px;\n\n    color: #6c757d;\n\n    font-size: 12px;\n}\n\n.spinner {\n    width: 14px;\n    height: 14px;\n\n    border-radius: 50%;\n\n    border: 2px solid #dee2e6;\n\n    border-top-color: var(--primary-blue-theme-color);\n\n    animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* =========================================\n   MOBILE\n========================================= */\n\n@media (max-width: 768px) {\n    .tableWrapper {\n        min-height: 200px;\n        max-height: 420px;\n    }\n\n    .mainTable thead th {\n        font-size: 9px;\n        padding: 0 3px;\n    }\n\n    .mainTable tbody td {\n        font-size: 10px;\n        padding: 3px 4px;\n    }\n}\n\n\n/* =====================================================================\n * FREQUENCY DISTRIBUTION TABLE\n * ===================================================================== */\n\n/* keeps the 11 columns readable on small screens; wrapper scrolls instead */\n.mainTable {\n    min-width: 760px;\n}\n\n.colLocation {\n    width: 17%;\n}\n\n.colCount {\n    width: 8%;\n}\n\n.colFreq {\n    width: 8%;\n}\n\n/* =========================================\n   CLICKABLE ROWS / CELLS\n========================================= */\n\n.cityRow,\n.depotRowClickable {\n    cursor: pointer;\n}\n\n.depotLink {\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: #697681;\n    font-size: 11px;\n    font-weight: 600;\n    text-align: left;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    cursor: pointer;\n}\n\n.depotLink:hover {\n    color: #4b71a2;\n    text-decoration: underline;\n}\n\n/* =========================================\n   DEPOT VEHICLES POPOVER\n========================================= */\n\n.popoverBody {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 12px 16px 4px;\n}\n\n.popoverMeta {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.metaChip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 8px;\n    border-radius: 10px;\n    background-color: #edf5fc;\n    color: #4b71a2;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.metaCount {\n    margin-left: auto;\n    color: #6b7280;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n/* download icon at the right of the card title row */\n.downloadBtn {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n\n    margin-right: 8px;\n    padding: 2px;\n    border: 0;\n    background: transparent;\n\n    color: #6b7280;\n    cursor: pointer;\n}\n\n.downloadBtn:hover {\n    color: #022352;\n}\n\n/* download icon right after the vehicle count */\n.metaDownload {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    color: #6b7280;\n    cursor: pointer;\n}\n\n.metaDownload:hover {\n    color: #022352;\n}\n\n/* vehicle multi-select: sits right after the city / date chips */\n.vehicleSelect {\n    position: relative;\n    /* above the table's sticky header (bootstrap .sticky-top = 1020) */\n    z-index: 1030;\n    margin-left: 4px;\n    font-size: 12px;\n}\n\n.vehicleMenuList {\n    /* search box width (min(270px, 80vw)) + its 8px margin on each side */\n    width: calc(min(270px, 80vw) + 16px);\n    max-height: 220px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    background-color: #fff;\n}\n\n.vehicleOption {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    color: #26384a;\n    font-size: 12px;\n    white-space: nowrap;\n    cursor: pointer;\n}\n\n.vehicleSelectAll {\n    position: sticky;\n    top: 0;\n    border-bottom: 1px solid #e5e7eb;\n    background-color: #fff;\n    font-weight: 600;\n}\n\n.vehicleOption:hover {\n    background-color: #edf5fc;\n}\n\n.vehicleOption input {\n    flex-shrink: 0;\n    margin: 0;\n}\n\n.popoverTableWrapper {\n    width: 100%;\n    max-height: 380px;\n    overflow: auto;\n    border-radius: 8px;\n}\n\n@media (max-width: 768px) {\n    .popoverBody {\n        padding: 10px 10px 4px;\n    }\n\n    .metaCount {\n        margin-left: 0;\n    }\n\n    .popoverTableWrapper {\n        max-height: 320px;\n    }\n}\n\n/* =========================================\n   COLUMN WIDTH OVERRIDES (after base widths)\n========================================= */\n\n.colStatus {\n    width: 5%;\n}\n\n.colBucket {\n    width: 8.5%;\n}\n\n/* =========================================\n   POPOVER: VIN column + table width\n========================================= */\n\n.colVin {\n    width: 20%;\n}\n\n.colReg {\n    width: 12%;\n}\n\n.popoverTable {\n    min-width: 820px;\n}\n\n.vinText {\n    color: #26384a;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.locationRow td {\n    background-color: #ffffff;\n}\n\n.locationRow:hover td {\n    background-color: #f8fbff;\n}\n\n.ignition {\n  --track-off: #dbe3f1;\n  --track-on: #5b86d6;\n  --knob: #ffffff;\n  --label: #2b3a55;\n  --state: #5b7bb5;\n\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  cursor: pointer;\n  user-select: none;\n  font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.label {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--label);\n}\n\n.switch {\n  position: relative;\n  width: 30px;\n  height: 15px;\n  flex: none;\n}\n\n.input {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  margin: 0;\n  cursor: pointer;\n}\n\n.track {\n  position: absolute;\n  inset: 0;\n  border-radius: 999px;\n  background: var(--track-off);\n  transition: background 0.2s ease;\n}\n\n.track::after {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background: var(--knob);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  transition: transform 0.2s ease;\n}\n\n.input:checked + .track {\n  background: var(--track-on);\n}\n\n.input:checked + .track::after {\n  transform: translateX(15px);\n}\n\n.input:focus-visible + .track {\n  outline: 2px solid var(--track-on);\n  outline-offset: 2px;\n}\n\n.state {\n  min-width: 32px;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--state);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `FrequencyBucketTable_card__B2mOT`,
	"cardHeader": `FrequencyBucketTable_cardHeader__j53zj`,
	"titleBar": `FrequencyBucketTable_titleBar__SXoW7`,
	"title": `FrequencyBucketTable_title__rAN-1`,
	"subtitle": `FrequencyBucketTable_subtitle__jQveM`,
	"tableWrapper": `FrequencyBucketTable_tableWrapper__ZIYdg`,
	"mainTable": `FrequencyBucketTable_mainTable__FBEuG`,
	"colCity": `FrequencyBucketTable_colCity__3J4h2`,
	"colStatus": `FrequencyBucketTable_colStatus__NR1Av`,
	"colDelayPct": `FrequencyBucketTable_colDelayPct__Ck71o`,
	"colNarrow": `FrequencyBucketTable_colNarrow__l7apc`,
	"colBucket": `FrequencyBucketTable_colBucket__c1loM`,
	"dataRow": `FrequencyBucketTable_dataRow__FFH1t`,
	"cityRow": `FrequencyBucketTable_cityRow__GT59c`,
	"cityRowActive": `FrequencyBucketTable_cityRowActive__Z3jFc`,
	"cityCell": `FrequencyBucketTable_cityCell__9hVxj`,
	"cityContent": `FrequencyBucketTable_cityContent__u0483`,
	"accordionIcon": `FrequencyBucketTable_accordionIcon__kvSZf`,
	"cityName": `FrequencyBucketTable_cityName__jCccL`,
	"depotRow": `FrequencyBucketTable_depotRow__8HWuW`,
	"depotSlideIn": `FrequencyBucketTable_depotSlideIn__cB7i0`,
	"depotCell": `FrequencyBucketTable_depotCell__drGxZ`,
	"depotName": `FrequencyBucketTable_depotName__Kfmmn`,
	"depotIndicator": `FrequencyBucketTable_depotIndicator__zqoaS`,
	"statusBadge": `FrequencyBucketTable_statusBadge__G7Z-m`,
	"statusHealthy": `FrequencyBucketTable_statusHealthy__m2k1W`,
	"statusUnhealthy": `FrequencyBucketTable_statusUnhealthy__3pmxR`,
	"delayPct": `FrequencyBucketTable_delayPct__ISuFb`,
	"bucketCell": `FrequencyBucketTable_bucketCell__CtAor`,
	"tone_green": `FrequencyBucketTable_tone_green__umHCs`,
	"tone_yellow": `FrequencyBucketTable_tone_yellow__xjg1C`,
	"tone_orange": `FrequencyBucketTable_tone_orange__Q4bfD`,
	"tone_red": `FrequencyBucketTable_tone_red__acoJi`,
	"tone_grey": `FrequencyBucketTable_tone_grey__HGuwZ`,
	"loadingState": `FrequencyBucketTable_loadingState__3xxbW`,
	"spinner": `FrequencyBucketTable_spinner__WAthB`,
	"spin": `FrequencyBucketTable_spin__BwEdW`,
	"colLocation": `FrequencyBucketTable_colLocation__Qm7PS`,
	"colCount": `FrequencyBucketTable_colCount__1GdRS`,
	"colFreq": `FrequencyBucketTable_colFreq__defC4`,
	"depotRowClickable": `FrequencyBucketTable_depotRowClickable__XahuF`,
	"depotLink": `FrequencyBucketTable_depotLink__FGFuZ`,
	"popoverBody": `FrequencyBucketTable_popoverBody__EEHD+`,
	"popoverMeta": `FrequencyBucketTable_popoverMeta__Dh6qj`,
	"metaChip": `FrequencyBucketTable_metaChip__0pdkP`,
	"metaCount": `FrequencyBucketTable_metaCount__0GHUq`,
	"downloadBtn": `FrequencyBucketTable_downloadBtn__vhOYd`,
	"metaDownload": `FrequencyBucketTable_metaDownload__nnD9o`,
	"vehicleSelect": `FrequencyBucketTable_vehicleSelect__M0WgG`,
	"vehicleMenuList": `FrequencyBucketTable_vehicleMenuList__LfL4p`,
	"vehicleOption": `FrequencyBucketTable_vehicleOption__VCDZo`,
	"vehicleSelectAll": `FrequencyBucketTable_vehicleSelectAll__WhaqX`,
	"popoverTableWrapper": `FrequencyBucketTable_popoverTableWrapper__2Z-Zg`,
	"colVin": `FrequencyBucketTable_colVin__qYsWO`,
	"colReg": `FrequencyBucketTable_colReg__6Kx6R`,
	"popoverTable": `FrequencyBucketTable_popoverTable__Qg2Yj`,
	"vinText": `FrequencyBucketTable_vinText__GRCUU`,
	"locationRow": `FrequencyBucketTable_locationRow__GOpA4`,
	"ignition": `FrequencyBucketTable_ignition__v-Oy1`,
	"label": `FrequencyBucketTable_label__QrlQD`,
	"switch": `FrequencyBucketTable_switch__J26qT`,
	"input": `FrequencyBucketTable_input__f4j9O`,
	"track": `FrequencyBucketTable_track__yeU9K`,
	"state": `FrequencyBucketTable_state__Elxx9`
};
export default ___CSS_LOADER_EXPORT___;
